import React, { useState } from 'react';
import '../../styles/midnight-lab.css';

function TasksModule() {
  const [tasks, setTasks] = useState([
    { id: 1, title: 'Order REV motors', description: 'Order 4 REV HD Hex motors for new robot', status: 'overdue', priority: 'high', dueAt: '2025-01-10', assignedTo: 'Alex J.', tags: ['inventory', 'urgent'] },
    { id: 2, title: 'Update robot CAD', description: 'Finalize CAD design for Decode robot', status: 'in-progress', priority: 'medium', dueAt: '2025-01-20', assignedTo: 'Sam C.', tags: ['design'] },
    { id: 3, title: 'Test autonomous routine', description: 'Test and refine autonomous path', status: 'todo', priority: 'high', dueAt: '2025-01-25', assignedTo: 'Jordan M.', tags: ['programming'] },
    { id: 4, title: 'Weekly team meeting', description: 'Review progress and plan next week', status: 'todo', priority: 'low', dueAt: '2025-01-18', assignedTo: 'All', tags: ['meeting'], recurring: 'weekly' }
  ]);
  const [filter, setFilter] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [newTask, setNewTask] = useState({
    title: '', description: '', status: 'todo', priority: 'medium', dueAt: '', assignedTo: '', tags: []
  });

  const statusColors = {
    todo: 'var(--color-text-secondary)',
    'in-progress': 'var(--color-frozen-lake)',
    overdue: 'var(--color-yellow-green)',
    completed: 'var(--color-text-secondary)'
  };

  const priorityColors = {
    low: 'var(--color-text-secondary)',
    medium: 'var(--color-frozen-lake)',
    high: 'var(--color-yellow-green)'
  };

  const filteredTasks = filter === 'all' 
    ? tasks 
    : tasks.filter(t => t.status === filter || (filter === 'due-soon' && isDueSoon(t.dueAt)));

  function isDueSoon(dueAt) {
    const due = new Date(dueAt);
    const now = new Date();
    const daysDiff = (due - now) / (1000 * 60 * 60 * 24);
    return daysDiff <= 7 && daysDiff >= 0;
  }

  const handleAddTask = () => {
    const task = { ...newTask, id: tasks.length + 1 };
    setTasks([...tasks, task]);
    setShowAddModal(false);
    setNewTask({ title: '', description: '', status: 'todo', priority: 'medium', dueAt: '', assignedTo: '', tags: [] });
  };

  const handleStatusChange = (taskId, newStatus) => {
    setTasks(tasks.map(t => t.id === taskId ? { ...t, status: newStatus } : t));
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        marginBottom: 'var(--space-8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--space-4)'
      }}>
        <div>
          <h1 style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            color: 'var(--color-text-primary)',
            marginBottom: 'var(--space-2)',
            letterSpacing: '-0.02em'
          }}>
            Tasks & Deadlines
          </h1>
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-secondary)'
          }}>
            Manage tasks, track deadlines, and assign work
          </p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          style={{
            padding: 'var(--space-3) var(--space-6)',
            backgroundColor: 'var(--color-text-primary)',
            color: 'var(--color-text-light)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
            transition: 'all var(--transition-base)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--color-frozen-lake)';
            e.target.style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--color-text-primary)';
            e.target.style.color = 'var(--color-text-light)';
          }}
        >
          + New Task
        </button>
      </div>

      {/* Filters */}
      <div style={{
        display: 'flex',
        gap: 'var(--space-2)',
        marginBottom: 'var(--space-6)',
        borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
        paddingBottom: 'var(--space-4)',
        flexWrap: 'wrap'
      }}>
        {['all', 'todo', 'in-progress', 'overdue', 'due-soon', 'completed'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: 'var(--space-2) var(--space-4)',
              backgroundColor: filter === f ? 'var(--color-text-primary)' : 'transparent',
              color: filter === f ? 'var(--color-text-light)' : 'var(--color-text-primary)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              border: 'none',
              cursor: 'pointer',
              textTransform: 'capitalize',
              transition: 'all var(--transition-base)'
            }}
          >
            {f.replace('-', ' ')}
          </button>
        ))}
      </div>

      {/* Tasks List */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-4)'
      }}>
        {filteredTasks.map(task => (
          <div
            key={task.id}
            style={{
              padding: 'var(--space-6)',
              borderBottom: '2px solid rgba(0, 16, 17, 0.1)',
              transition: 'all var(--transition-base)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateX(4px)';
              e.currentTarget.style.borderBottomColor = 'var(--color-frozen-lake)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateX(0)';
              e.currentTarget.style.borderBottomColor = 'rgba(0, 16, 17, 0.1)';
            }}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: 'var(--space-3)',
              flexWrap: 'wrap',
              gap: 'var(--space-4)'
            }}>
              <div style={{ flex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-3)',
                  marginBottom: 'var(--space-2)',
                  flexWrap: 'wrap'
                }}>
                  <h3 style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-xl)',
                    fontWeight: 600,
                    color: 'var(--color-text-primary)'
                  }}>
                    {task.title}
                  </h3>
                  {task.recurring && (
                    <span style={{
                      padding: 'var(--space-1) var(--space-2)',
                      backgroundColor: 'var(--color-bg-secondary)',
                      fontFamily: 'var(--font-sans)',
                      fontSize: 'var(--text-xs)',
                      color: 'var(--color-text-secondary)',
                      textTransform: 'uppercase'
                    }}>
                      Recurring
                    </span>
                  )}
                </div>
                <p style={{
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-base)',
                  color: 'var(--color-text-secondary)',
                  lineHeight: 1.6,
                  marginBottom: 'var(--space-3)'
                }}>
                  {task.description}
                </p>
                <div style={{
                  display: 'flex',
                  gap: 'var(--space-3)',
                  flexWrap: 'wrap',
                  alignItems: 'center'
                }}>
                  <div style={{
                    padding: 'var(--space-1) var(--space-3)',
                    backgroundColor: statusColors[task.status] + '20',
                    color: statusColors[task.status],
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-xs)',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    borderRadius: '4px'
                  }}>
                    {task.status.replace('-', ' ')}
                  </div>
                  <div style={{
                    padding: 'var(--space-1) var(--space-3)',
                    backgroundColor: priorityColors[task.priority] + '20',
                    color: priorityColors[task.priority],
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-xs)',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    borderRadius: '4px'
                  }}>
                    {task.priority}
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--color-text-secondary)'
                  }}>
                    Due: {new Date(task.dueAt).toLocaleDateString()}
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--color-text-secondary)'
                  }}>
                    Assigned: {task.assignedTo}
                  </div>
                </div>
                {task.tags && task.tags.length > 0 && (
                  <div style={{
                    display: 'flex',
                    gap: 'var(--space-2)',
                    marginTop: 'var(--space-3)',
                    flexWrap: 'wrap'
                  }}>
                    {task.tags.map(tag => (
                      <span
                        key={tag}
                        style={{
                          padding: 'var(--space-1) var(--space-2)',
                          backgroundColor: 'var(--color-bg-secondary)',
                          fontFamily: 'var(--font-sans)',
                          fontSize: 'var(--text-xs)',
                          color: 'var(--color-text-secondary)',
                          borderRadius: '4px'
                        }}
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <select
                value={task.status}
                onChange={(e) => handleStatusChange(task.id, e.target.value)}
                style={{
                  padding: 'var(--space-2) var(--space-3)',
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-sm)',
                  border: '1px solid rgba(0, 16, 17, 0.1)',
                  backgroundColor: 'var(--color-bg-primary)',
                  color: 'var(--color-text-primary)',
                  cursor: 'pointer'
                }}
              >
                <option value="todo">To Do</option>
                <option value="in-progress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      {/* Add Task Modal */}
      {showAddModal && (
        <div
          onClick={() => setShowAddModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 16, 17, 0.8)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'var(--space-4)'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              padding: 'var(--space-8)',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}
          >
            <h2 style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-2xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-6)'
            }}>
              Create New Task
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              <div>
                <label style={labelStyle}>Title</label>
                <input
                  type="text"
                  value={newTask.title}
                  onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Description</label>
                <textarea
                  value={newTask.description}
                  onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                  style={{ ...inputStyle, minHeight: '100px', resize: 'vertical' }}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-4)' }}>
                <div>
                  <label style={labelStyle}>Priority</label>
                  <select
                    value={newTask.priority}
                    onChange={(e) => setNewTask({ ...newTask, priority: e.target.value })}
                    style={inputStyle}
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Due Date</label>
                  <input
                    type="date"
                    value={newTask.dueAt}
                    onChange={(e) => setNewTask({ ...newTask, dueAt: e.target.value })}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Assigned To</label>
                <input
                  type="text"
                  value={newTask.assignedTo}
                  onChange={(e) => setNewTask({ ...newTask, assignedTo: e.target.value })}
                  style={inputStyle}
                  placeholder="Team member name"
                />
              </div>
            </div>
            <div style={{
              display: 'flex',
              gap: 'var(--space-4)',
              marginTop: 'var(--space-6)'
            }}>
              <button onClick={handleAddTask} style={buttonStyle}>
                Create Task
              </button>
              <button onClick={() => setShowAddModal(false)} style={{ ...buttonStyle, backgroundColor: 'transparent', color: 'var(--color-text-primary)' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const labelStyle = {
  display: 'block',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-sm)',
  fontWeight: 600,
  color: 'var(--color-text-primary)',
  marginBottom: 'var(--space-2)'
};

const inputStyle = {
  width: '100%',
  padding: 'var(--space-3)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  border: '1px solid rgba(0, 16, 17, 0.1)',
  backgroundColor: 'var(--color-bg-primary)',
  color: 'var(--color-text-primary)'
};

const buttonStyle = {
  padding: 'var(--space-3) var(--space-6)',
  backgroundColor: 'var(--color-text-primary)',
  color: 'var(--color-text-light)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  fontWeight: 600,
  border: 'none',
  cursor: 'pointer',
  transition: 'all var(--transition-base)'
};

export default TasksModule;

